// extracted by mini-css-extract-plugin
export default {"container":"layout_container__Clv0L","aside":"layout_aside__O8cJo","wrapper":"layout_wrapper__6+NoK","header":"layout_header__tMl-o"};